module.exports = __webpack_public_path__ + "src/assets/img/03.6d35d70c.png";